import styled from 'styled-components';
import UL from './UL';

const OL = styled(UL)``;
OL.defaultProps = { as: 'ol' };

export default OL;
